import env from '@ludovicm67/react-dotenv';

// fetch values from config
export const publicUrl = env.PUBLIC_URL;
export const gitlabUrl = env.GITLAB;
export const clientId = env.OIDC_CLIENT_ID;
